import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import qs from 'query-string';
import OktaWidgetWrapper, {
  isLoginRedirect,
  getWithRedirect,
  hideWidget,
} from '../../components/OktaWidget/okta-widget-wrapper';
import { getAppsFromAccessToken, setOrRemoveRedirectUrl } from '../../okta';
import 'url-polyfill';
import { ROUTES } from '../../navigation/router';
import { useOktaAuth } from '@okta/okta-react';
import Loader from '@tcl-boron-prefabs/loader';
import logger from '../../utils/logger';
import cn from 'classnames';
import withStyles from '@tempus/component-library/utils/withStyles';
import styles from '../../styles';

function SignIn({ classes }) {
  const history = useHistory();
  const { authState } = useOktaAuth();
  const [loading, setLoading] = useState(false);

  const navToAppSwitcher = useCallback(async () => {
    if (authState && authState.isAuthenticated) {
      const apps = getAppsFromAccessToken(authState.accessToken);
      history.push(ROUTES.APP_SWITCHER, { apps });
    }
  }, [authState, history]);

  const handleFromLoginRedirect = useCallback(async () => {
    // If we are redirected back from okta after SSO login
    // Get an access token, read it, and redirect
    hideWidget();

    await getWithRedirect();
  }, []);

  const tryRedirecting = useCallback(
    async (queryObj) => {
      const hasFromLoginQueryParam = queryObj?.fromLogin || isLoginRedirect();
      const hasAutoRedirectQueryParam = queryObj?.autoRedirect;
      const hasRedirectQueryParam = queryObj?.redirect;

      // Set or remove ?redirect= if available
      // Actual redirect handled by AppSwitcher
      setOrRemoveRedirectUrl(queryObj?.redirect);

      // Handle ?fromLogin= if available
      if (hasFromLoginQueryParam) {
        await handleFromLoginRedirect();
      }
      // Handle ?redirect= if available
      else if (hasRedirectQueryParam) {
        await navToAppSwitcher();
      }
      // Handle ?autoRedirect=true if available
      // May not be used anymore
      else if (hasAutoRedirectQueryParam) {
        await getWithRedirect();
      } else {
        logger.error('Unknown redirect state', queryObj);
      }
    },
    [handleFromLoginRedirect, navToAppSwitcher],
  );

  useEffect(() => {
    const queryObj = qs.parse(window.location.search);
    // Redirect if query params are present
    if (Object.keys(queryObj).length > 0) {
      tryRedirecting(queryObj);
    } else {
      if (!authState || !authState.isAuthenticated) {
        setOrRemoveRedirectUrl();
      }
    }

    // Only when authenticated, no-op otherwise
    navToAppSwitcher();
    setLoading(false);
  }, [authState, tryRedirecting, history, navToAppSwitcher]);

  if (loading || authState === undefined)
    return (
      <div className={cn('app-view-container', classes.loadingContainer)}>
        <Loader />
      </div>
    );
  return <OktaWidgetWrapper />;
}

export default withStyles(styles)(SignIn);
